<template>
  <div id="calibrate">
    <div class="top">
      <p v-wave class="tabName" :class="item.status ? 'tabNameActive' : ''" v-for="item in tabList" :key="item.value" @click="tabChange(item)">
        {{$t(item.name)}}
      </p>
    </div>
    <div class="bottom" v-show="tabList[0].status">
      <div class="switchBox">
        <div class="switch" style="margin-bottom: 0.2rem">
          <h4>{{$t('自动校准')}}</h4>
          <el-switch v-model="autoCalibrate" inactive-color="#888888" @change="openAutoCalibrate"></el-switch>
        </div>
        <div class="switch" style="margin-bottom: 0.2rem">
          <el-alert
            type="warning"
            :center="false"
            :closable="false"
            :description="$t('提示内容17')"
            show-icon>
          </el-alert>
        </div>
        <div class="switch">
          <h4>{{$t('显示校准数据')}}</h4>
          <el-switch v-model="displayData" inactive-color="#888888" @change="displayDataChange"></el-switch>
        </div>
      </div>
      <div class="tipsBox">
        <p class="tips">
          {{ '1.' + $t('提示内容18')}}
        </p>
        <p class="tips">
          {{ '2.' + $t('提示内容19')}}
        </p>
        <p class="tips">
          {{ '3.' + $t('提示内容20')}}
        </p>
        <p class="tips">
          {{ '4.' + $t('提示内容21')}}
        </p>
        <p class="tips">
          {{ '5.' + $t('提示内容22')}}
        </p>
        <p class="tips">
          <el-alert
            type="info"
            :center="false"
            :closable="false"
            :description="$t('提示内容60')"
            show-icon>
          </el-alert>
        </p>
      </div>
      <div class="buttonBox">
        <el-button v-wave type="primary" :loading="isBegin" @click="fullKeyCalibration">{{$t('开始校准')}}</el-button>
        <el-button v-wave type="info" :disabled="!isBegin" @click="stopKeyCalibration">{{$t('放弃校准')}}</el-button>
        <el-button v-wave type="success" :disabled="!isPermit" @click="finishCalibration">{{$t('完成校准')}}</el-button>
      </div>
    </div>
<!--    <div class="bottom" v-show="tabList[1].status">-->
<!--      <heightChart></heightChart>-->
<!--    </div>-->
  </div>
</template>

<script>
// import heightChart from "@/components/heightChart";
import EventBus from "@/store/eventBus";
import { key_zent75_address } from '@/store/state'
export default {
  name: "calibrateComponent",
  components: {
    // heightChart
  },
  data() {
    return {
      isConnected: false,
      addressList: key_zent75_address, // 默认75配列
      tabList:[
        {
          name: '校准',
          value: '0',
          status: true
        },
        // {
        //   name: '试轴器',
        //   value: '1',
        //   status: false
        // }
      ],
      autoCalibrate: false, // 是否开启自动校准
      displayData: true,
      isBegin: false,
      isPermit: false,
    }
  },
  mounted() {
    EventBus.$on('connected', this.getConnectedResult)
    EventBus.$on('sendFinish', () => {
      this.isBegin = false
      EventBus.$emit('autoCalibSave')
    })
    EventBus.$on('permitClick',(val) => {
      this.isPermit = val
    })
    EventBus.$on('getRgbSwitchData',(arr) => {
      this.autoCalibrate = arr[9] === 1
    })
    EventBus.$on('getInitializeResult', (obj) => {
      this.addressList = obj.addressList
    })
  },
  methods: {
    // 获取键盘连接状态回调
    getConnectedResult(val) {
      this.isConnected = val
    },
    // 自动校准
    async openAutoCalibrate() {
      if (this.isConnected) {
        if (this.autoCalibrate) {
          this.$emit('set', this.addressList.auto_calib_enable.address, [1], this.addressList.auto_calib_enable.length)
        } else {
          this.$emit('set', this.addressList.auto_calib_enable.address, [0], this.addressList.auto_calib_enable.length)
        }
        EventBus.$emit('autoCalibSave')
      }
    },
    displayDataChange() {
      EventBus.$emit('displayData',this.displayData)
    },
    tabChange(obj) {
      this.tabList.forEach(e => {
        if (obj.value === e.value) {
          e.status = true
          EventBus.$emit('calTabChange',e.value)
        } else {
          e.status = false
        }
      })
    },
    async fullKeyCalibration() {
      this.isBegin = true
      EventBus.$emit('startCal', this.isBegin)
    },
    stopKeyCalibration() {
      this.$emit('calib',0)
      setTimeout(() => {
        this.$notify.info({
          title: this.$t('提示'),
          message: this.$t('已放弃校准'),
          offset: 100
        })
        this.isBegin = false
        EventBus.$emit('stopCal')
      },2000)
    },
    finishCalibration() {
      EventBus.$emit('finishSubmit')
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../style/handle.scss';
  #calibrate {
    width: 100%;
    display: flex;
    flex-direction: column;
    .top {
      flex: 0 0 auto;
      display: flex;
      justify-content: center;
      margin-bottom: 0.2rem;
      border-bottom: 0.03rem solid;
      @include border_color('border-bottom-color');
      height: 0.5rem;
      .tabName {
        width: 3rem;
        height: 0.5rem;
        font-weight: 700;
        //line-height: 40px;
        text-align: center;
        margin-right: 0.05rem;
        //box-shadow: 0 5px 12px rgba(0,0,0,0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.15rem;
      }

      .tabNameActive {
        color: #409EFF;
        border-bottom: 0.03rem solid #409EFF;
      }
    }
    .bottom {
      flex: 1 1 auto;
      width: 100%;
      overflow: auto;
      //min-height: 500px;
      //min-width: 1400px;
      .tipsBox {
        padding: 0 0.2rem;
        width: 100%;
        text-align: -webkit-center;
        font-size: 0.12rem;
        .tips {
          margin: 0.1rem 0;
          color: #888888;
          max-width: 60%;
          text-align: start;
        }
      }
      .switchBox {
        padding: 0 0.2rem;
        width: 100%;
        text-align: -webkit-center;
        margin-bottom: 0.2rem;
        .switch {
          max-width: 60%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          h4 {
            font-size: 0.15rem;
          }
          /deep/.el-switch {
            font-size: 0.14rem !important;
            line-height: 0.2rem !important;
            height: 0.2rem !important;
            .el-switch__label {
              height: 0.2rem;
              font-size: 0.14rem !important;
              span {
                font-size: 0.14rem !important;
              }
            }
            .el-switch__label--left {
              margin-right: 0.1rem;
            }
            .el-switch__label--right {
              margin-left: 0.1rem;
            }
            .el-switch__core {
              width: 0.4rem !important;
              height: 0.2rem;
              border-radius: 0.1rem;
              border-width: 0.01rem;
            }
            .el-switch__core:after {
              top: 0.01rem;
              left: 0.01rem;
              width: 0.16rem;
              height: 0.16rem;
            }
          }
          /deep/.el-switch.is-checked .el-switch__core::after {
            margin-left: 0.19rem !important;
          }
        }
      }
      .buttonBox {
        padding: 0 0.2rem;
        width: 100%;
        text-align: -webkit-center;
        margin: 0.5rem 0;
        .el-button {
          font-size: 0.14rem;
          padding: 0.12rem 0.2rem;
          border-radius: 0.04rem;
        }
      }
    }
  }
</style>
